import * as Icons from '@lucide/svelte';
import type { IconType } from '../../components/icons/icons.types';

/**
 * The icons of the Users module, in one place: PageService, pages, buttons and boxes take them from here. A `…Create`
 * icon is the one of the "anlegen" button — `PageDefinition.createIcon`, `Icons.Plus` without one.
 */
class UsersIconsClass {
    public readonly Team: IconType = Icons.UsersRound;
    public readonly User: IconType = Icons.Users;
    public readonly UserCreate: IconType = Icons.UserPlus;
}

export const UsersIcons = new UsersIconsClass();
